








































import { mixins } from 'vue-class-component'
import { Component, Prop, Watch, Emit } from 'vue-property-decorator'

import AppDialog from '@/components/AppDialog.vue'
import AppRadio from '@/components/AppRadio.vue'
import AppTextSearch from '@/components/AppTextSearch.vue'
import { generateAcordForm, getAcordFormTemplates } from '@/modules/AcordForm/gql/acord-form.gql'
import { Policy } from '@/modules/Policy/interfaces/policy'
import { Quote } from '@/modules/Quote/interfaces/quote'
import { Agency } from '@/modules/Agency/interfaces/agency'
import { AcordFormTemplate } from '@/modules/AcordForm/interfaces/acord-form'
import { SnackType } from '@/interfaces/snack'
import { showErrors, showNotification } from '@/utils/snack'
import { CertificateOfInsurance } from '@/modules/CertificateOfInsurance/interfaces/certificate-of-insurance'
import SearchAgency from '@/mixins/search-queries/search-agency'
import { formatPhoneNumber } from '@/utils/phoneNumberFormat'

@Component({
  components: {
    AppDialog,
    AppRadio,
    AppTextSearch
  }
})
export default class AcordFormDialog extends mixins(SearchAgency) {
  @Prop(Boolean) readonly value!: boolean
  @Prop({ type: Object as () => Policy }) readonly policy!: Policy
  @Prop({ type: Object as () => Quote }) readonly quote!: Quote
  @Prop({ type: Object as () => CertificateOfInsurance }) readonly certificate!: CertificateOfInsurance

  showDialog = false

  agencyDialog = {
    show: false,
    title: 'Choose Agency'
  }

  agencyInput = {
    agency: {
      id: undefined,
      name: ''
    }
  }

  acordFormTemplateList: AcordFormTemplate[] = []

  acordFormIndex = -1

  searchVal = ''

  get acordFormNames () {
    return this.acordFormTemplateList.map(template => template.templateFileName)
  }

  @Watch('value')
  valueChanged (val: boolean) {
    this.agencyDialog.show = val
    if (val === true) {
      this.getAcordFormTemplate()
      this.searchVal = ''
    }
  }

  @Emit('post')
  onPostHandler () {
    this.acordFormIndex = -1
    this.agencyInput.agency.name = ''
    this.showDialog = false
    this.agencyDialog.show = false
  }

  generateAcordFormConfirm () {
    this.generateAcordFormRequest()
  }

  async generateAcordFormRequest () {
    let masterType = ''
    let masterId = -1
    let data = ''

    if (!this.policy && !this.quote && !this.certificate) {
      return
    }

    const agency = this.agencyInput.agency as any

    const contactPhone = agency.phone ? formatPhoneNumber(agency.phone, agency.countryCode, agency.extensionNumber) : ''
    const contactFax = agency.fax ? formatPhoneNumber(agency.fax, agency.faxCountryCode, agency.faxExtensionNumber) : ''

    if (this.policy) {
      masterType = 'POLICY'
      masterId = Number(this.policy.id)
      data = JSON.stringify(Object.assign(this.policy, {
        agency,
        contactPhone,
        contactFax
      }))
    } else if (this.quote) {
      masterType = 'QUOTE'
      masterId = Number(this.quote.id)
      data = JSON.stringify(Object.assign(this.quote, {
        agency,
        contactPhone,
        contactFax
      }))
    } else {
      masterType = 'COI'
      masterId = Number(this.certificate.id)
      data = JSON.stringify(Object.assign(this.certificate, {
        agency,
        contactPhone,
        contactFax
      }))
    }

    const templateId = Number(this.acordFormTemplateList[this.acordFormIndex].id)

    this.onPostHandler()

    try {
      const res = await this.$apollo.mutate({
        mutation: generateAcordForm,
        variables: {
          input: {
            masterType,
            masterId,
            templateId,
            data
          }
        }
      })

      if (res) {
        showNotification({
          msg: 'Generate ACORD Form successfully',
          type: SnackType.Success
        })
      }
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  filterAcordFormList () {
    this.getAcordFormTemplate()
  }

  async getAcordFormTemplate () {
    let type = ''
    if (this.policy) {
      type = 'policy'
    } else if (this.quote) {
      type = 'quote'
    } else {
      type = 'coi'
    }

    try {
      const res = await this.$apollo.query({
        query: getAcordFormTemplates,
        variables: {
          type: type,
          query: this.searchVal
        }
      })

      if (res) {
        this.acordFormTemplateList = res.data.getAcordFormTemplates
      }
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  selectActionConfirm () {
    const agencyValid = (this.$refs.agencyForm as Vue & { validate: () => boolean }).validate()
    if (!agencyValid) {
      return
    }

    this.agencyDialog.show = false
    this.showDialog = true
  }

  backHandler () {
    this.showDialog = false
    this.agencyDialog.show = true
  }

  clearAgencyInput () {
    this.agencyInput = {
      agency: {
        id: undefined,
        name: ''
      }
    }
    this.showDialog = false
    this.onPostHandler()
  }
}
